export const STATUS_REVIEW = 'REVIEW';
export const STATUS_COMPLETE = 'COMPLETE';
export const STATUS_DENY = 'DENY';

export const REQUEST_ACCESS_STATUS_VALUES = [STATUS_REVIEW, STATUS_COMPLETE, STATUS_DENY];

export const requestAccessSortKeys = Object.freeze({
  EMAIL: 'email',
  WORKSPACE: 'workspace',
  MANAGER: 'manager',
  REASON: 'reason',
  DATE: 'date',
  STATUS: 'status',
});

export const sortType = Object.freeze({
  ASC: 'asc',
  DESC: 'desc',
});
